import apiClient from './apiClient';
import { CREATE_TAG, GET_TAGS } from '../constants/UriConstants';
import { CreateTagResponseInterface, TagInterface } from '../types/TagInterface';

export const createTag = (name: string, color: string): Promise<CreateTagResponseInterface> =>
  apiClient.post(CREATE_TAG, { name, color }).then((response) => response.data);

export const getTags = (): Promise<TagInterface[]> => apiClient.get(GET_TAGS).then((response) => response.data);
